// Copyright © 2023 Move Closer
import { AbstractIntention } from '@movecloser/front-core';
/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export class LoginIntention extends AbstractIntention {
    constructor() {
        super(...arguments);
        this.map = {
            code: 'code',
            token: 'token',
            email: 'email',
            grantType: 'grantType',
            password: 'password',
            remember: 'remember'
        };
    }
}
